import { InquiryFitBadge } from "@/components/bookings/InquiryFitBadge";
import { PitchPlanBadge } from "@/components/bookings/PitchPlanBadge";
import type { Booking } from "@/types/camping";

export interface PitchPlanCellProps {
  booking: Booking;
  pitchLabel: string;
  onPitchClick?: () => void;
}

export function PitchPlanCell({ booking, pitchLabel, onPitchClick }: PitchPlanCellProps) {
  return (
    <div className="flex flex-col items-start gap-1">
      {onPitchClick ? (
        <button
          type="button"
          className="text-left text-accent hover:underline"
          onClick={(e) => {
            e.stopPropagation();
            onPitchClick();
          }}
        >
          {pitchLabel}
        </button>
      ) : (
        <span>{pitchLabel}</span>
      )}
      <PitchPlanBadge booking={booking} />
      {booking.status === "requested" ? <InquiryFitBadge offer={booking.inquiry_offer} /> : null}
    </div>
  );
}
